import React, { useState } from "react";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";
import InfoUserModal from "../modal/InfoUserModal";

const UsersTree = () => {
  const [infoModal, setInfoModal] = useState(false);
  const proHeight = document.body.clientHeight;

  const data = {
    id: "A0",
    level: "group",
    value: {
      title: "John Doe",
      items: [
        {
          text: "CEO",
        },
        {
          text: "Hayleys group",
        },
      ],
    },
    children: [
      {
        id: "A1",
        level: "company",
        value: {
          title: "Kevin Hart",
          items: [
            {
              text: "CEO",
            },
            {
              text: "Kingsbury",
            },
          ],
        },
        children: [
          {
            id: "A11",
            level: "department",
            value: {
              title: "Ryan Rey",
              items: [
                {
                  text: "MD",
                },
                {
                  text: "Finance",
                },
              ],
            },
            children: [
              {
                id: "A111",
                level: "division",
                value: {
                  title: "John Stock",
                  items: [
                    {
                      text: "Manager",
                    },
                    {
                      text: "Division 1",
                    },
                  ],
                },
              },
              {
                id: "A112",
                level: "division",
                value: {
                  title: "David Rob",
                  items: [
                    {
                      text: "Manager",
                    },
                    {
                      text: "Division 2",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A12",
            level: "department",
            value: {
              title: "Mark Ruf",
              items: [
                {
                  text: "MD",
                },
                {
                  text: "HR",
                },
              ],
            },
          },
          {
            id: "A13",
            level: "company",
            value: {
              title: "Mike Jord",
              items: [
                {
                  text: "COO",
                },
                {
                  text: "Kingbury",
                },
              ],
            },
          },
        ],
      },
      {
        id: "A2",
        level: "company",
        value: {
          title: "Kobe Bry",
          items: [
            {
              text: "CEO",
            },
            {
              text: "Alumex",
            },
          ],
        },
        children: [
          {
            id: "A21",
            level: "department",
            value: {
              title: "Aron Bever",
              items: [
                {
                  text: "MD",
                },
                {
                  text: "Sales",
                },
              ],
            },
            children: [
              {
                id: "A211",
                level: "division",
                value: {
                  title: "Magic John",
                  items: [
                    {
                      text: "Manager",
                    },
                    {
                      text: "Division 1",
                    },
                  ],
                },
              },
              {
                id: "A212",
                level: "division",
                value: {
                  title: "Larry Bir",
                  items: [
                    {
                      text: "Manager",
                    },
                    {
                      text: "Division 2",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A22",
            level: "department",
            value: {
              title: "Scot Pippen",
              items: [
                {
                  text: "MD",
                },
                {
                  text: "Marketing",
                },
              ],
            },
          },
        ],
      },
    ],
  };

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    if (node.level === "group") {
      nodeColor = "rgb(63, 81, 181)";
    } else if (node.level === "company") {
      nodeColor = "rgb(244, 67, 54)";
    } else if (node.level === "department") {
      nodeColor = "rgb(76, 175, 80)";
    } else if (node.level === "division") {
      nodeColor = "rgb(255, 193, 7)";
    }
    return nodeColor;
  }

  const config = {
    data,
    height: proHeight - 172,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    edgeCfg: {
      type: "polyline",
      endArrow: true,
    },
    autoFit: false,
  };

  return (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setInfoModal(true);
            });
          }}
        />
      </div>
      <InfoUserModal
        visible={infoModal}
        handleCancel={() => setInfoModal(false)}
      />
    </>
  );
};

export default UsersTree;
